// extracted by css-extract-rspack-plugin
export default {"itemWithTrailingAction":"NavigationItem-module__itemWithTrailingAction__ox4sQ","rerunButton":"NavigationItem-module__rerunButton__i2fyk"};